// src/pages/Login/ResetSuccess/index.tsx
import React from 'react'
import OrdenoLogo from '../Login/img-login/ordeno-logo.png'
import {
  FullPageWrapper,
  Logo,
  IconCircle,
  Title,
  Subtitle,
  BackRow,
  BackIcon,
  BackText,
} from './style6'

interface ResetSuccessProps {
  setPage: (page: string) => void
}

const ResetSuccess: React.FC<ResetSuccessProps> = ({ setPage }) => {
  return (
    <FullPageWrapper>
      {/* logo ordeno */}
      <Logo src={OrdenoLogo} alt='ordeno' />

      {/* ícone verdinho de sucesso */}
      <IconCircle>✓</IconCircle>

      {/* textos */}
      <Title>Senha redefinida com sucesso</Title>
      <Subtitle>Você já pode fazer o login</Subtitle>

      {/* link para voltar pro login */}
      <BackRow onClick={() => setPage('Main')}>
        <BackIcon>←</BackIcon>
        <BackText>Voltar ao login</BackText>
      </BackRow>
    </FullPageWrapper>
  )
}

export default ResetSuccess
